export const ORDER_STATUSES = {
  placed:     { label: 'Размещён',    color: 'bg-blue-900/50 text-blue-300 border-blue-700' },
  production: { label: 'Изготовление', color: 'bg-yellow-900/50 text-yellow-300 border-yellow-700' },
  ready:      { label: 'Готов',       color: 'bg-green-900/50 text-green-300 border-green-700' },
  shipped:    { label: 'Отгружен',    color: 'bg-purple-900/50 text-purple-300 border-purple-700' },
  archived:   { label: 'Архив',       color: 'bg-gray-800 text-gray-400 border-gray-600' },
};
export const REPAIR_STATUSES = {
  pending:     { label: 'Ожидает отправки', color: 'bg-gray-700 text-gray-300 border-gray-600',     dealerAction: true },
  received:    { label: 'Принят в работу',  color: 'bg-blue-900/50 text-blue-300 border-blue-700' },
  diagnostics: { label: 'Диагностика',      color: 'bg-cyan-900/50 text-cyan-300 border-cyan-700' },
  repair:      { label: 'Ремонт',           color: 'bg-yellow-900/50 text-yellow-300 border-yellow-700' },
  ready:       { label: 'Готов к отправке', color: 'bg-green-900/50 text-green-300 border-green-700' },
  shipped:     { label: 'Отправлен дилеру', color: 'bg-purple-900/50 text-purple-300 border-purple-700' },
  returned:    { label: 'Получен дилером',  color: 'bg-teal-900/50 text-teal-300 border-teal-700',   dealerAction: true },
  archived:    { label: 'Архив',            color: 'bg-gray-800 text-gray-400 border-gray-600' },
};
export const SUPPLY_STATUSES = {
  awaiting_payment:    { label: 'Ожидание оплаты',       color: 'bg-red-900/50 text-red-300 border-red-700' },
  negotiations:        { label: 'Переговоры',            color: 'bg-orange-900/50 text-orange-300 border-orange-700' },
  payment_sent:        { label: 'Деньги переведены',     color: 'bg-yellow-900/50 text-yellow-300 border-yellow-700' },
  manufacturing:       { label: 'Изготовление',          color: 'bg-amber-900/50 text-amber-300 border-amber-700' },
  shipped_by_supplier: { label: 'Отгружено поставщиком', color: 'bg-cyan-900/50 text-cyan-300 border-cyan-700' },
  in_transit:          { label: 'В пути',                color: 'bg-blue-900/50 text-blue-300 border-blue-700' },
  received:            { label: 'Получено на склад',     color: 'bg-teal-900/50 text-teal-300 border-teal-700' },
  shipped_to_dealer:   { label: 'Отгружено дилеру',      color: 'bg-green-900/50 text-green-300 border-green-700' },
};
export const FILE_TYPES = {
  invoice:      'Счёт',
  shipping_doc: 'Отгрузочные документы',
  passport:     'Паспорт',
  photo:        'Фото',
  diagnostics:  'Диагностика',
  act:          'Акт выполненных работ',
  other:        'Прочее',
};
export const ROLES = {
  superadmin:       { label: 'Суперадмин',    color: 'bg-red-900/50 text-red-300' },
  producer_manager: { label: 'Менеджер',      color: 'bg-blue-900/50 text-blue-300' },
  dealer_admin:     { label: 'Дилер (адм)',   color: 'bg-purple-900/50 text-purple-300' },
  dealer_user:      { label: 'Дилер',         color: 'bg-gray-800 text-gray-400' },
};
export const ALL_PERMISSIONS = [
  { section: 'orders',   perm: 'view',              label: 'Заказы: просмотр' },
  { section: 'orders',   perm: 'create',            label: 'Заказы: создание' },
  { section: 'orders',   perm: 'edit_content',      label: 'Заказы: редактирование содержания' },
  { section: 'orders',   perm: 'edit_status',       label: 'Заказы: смена статуса' },
  { section: 'orders',   perm: 'edit_progress',     label: 'Заказы: изменение прогресса' },
  { section: 'orders',   perm: 'delete',            label: 'Заказы: удаление' },
  { section: 'orders',   perm: 'view_prices',       label: 'Заказы: видеть цены' },
  { section: 'orders',   perm: 'view_all_comments', label: 'Заказы: видеть внутренние комментарии' },
  { section: 'orders',   perm: 'add_payment',       label: 'Заказы: добавлять платежи' },
  { section: 'repairs',  perm: 'view',              label: 'Ремонт: просмотр' },
  { section: 'repairs',  perm: 'create',            label: 'Ремонт: создание' },
  { section: 'repairs',  perm: 'edit',              label: 'Ремонт: редактирование' },
  { section: 'repairs',  perm: 'edit_status',       label: 'Ремонт: смена статуса' },
  { section: 'repairs',  perm: 'view_prices',       label: 'Ремонт: видеть цены' },
  { section: 'repairs',  perm: 'add_payment',       label: 'Ремонт: добавлять платежи' },
  { section: 'supplies', perm: 'view',              label: 'Поставки: просмотр' },
  { section: 'supplies', perm: 'create',            label: 'Поставки: создание' },
  { section: 'supplies', perm: 'edit_content',      label: 'Поставки: редактирование' },
  { section: 'supplies', perm: 'edit_status',       label: 'Поставки: смена статуса' },
  { section: 'supplies', perm: 'add_payment',       label: 'Поставки: добавлять платежи' },
  { section: 'files',    perm: 'upload',            label: 'Файлы: загрузка' },
  { section: 'files',    perm: 'delete',            label: 'Файлы: удаление' },
];
